import importerActions from 'modules/shared/importer/importerActions';
import selectors from 'modules/bot/importer/botImporterSelectors';
import BotService from 'modules/bot/botService';
import fields from 'modules/bot/importer/botImporterFields';
import { i18n } from 'i18n';

export default importerActions(
  'BOT_IMPORTER',
  selectors,
  BotService.import,
  fields,
  i18n('entities.bot.importer.fileName'),
);
